/**
 * Get localized resource string for ButtonGrid component
 * @param {string} label - Resource key to retrieve (e.g., 'paypalLoading', 'paypalButton')
 * @param {Array} vars - Optional array of variables for string interpolation (currently unused)
 * @returns {string} Localized string for the given label
 */
export default function getResource(label, vars = []) {
    const resources = {
        paypalLoading: 'Loading PayPal',
        paypalButton: 'PayPal Button'
    };

    return resources[label];
}
